<template>
    <div class="menu d-grid gap-2">
        <template v-for="(n, i) in nav">
            <button
                v-if="n.scrollTo"
                :key="'nav-' + i"
                v-scroll-to="n.scrollTo"
                type="button"
                class="btn"
                :class="{ active: current == i }"
                @click="() => $emit('force-nav', i)"
            >
                {{ n.label }}
            </button>

            <router-link
                v-else-if="n.to"
                :key="'enav-' + i"
                :to="n.to"
                class="btn"
                custom v-slot="{ navigate }"
            >
                <button @click="navigate" @keypress.enter="navigate" class="btn" :class="{ active: current == i }">{{ n.label }}</button>
            </router-link>

            <button :key="'bnav-' + i" v-else type="button" class="btn premium" disabled>
                <span class="blurry-light">{{ n.label }}</span>
                <PremiumLabel />
            </button>
        </template>
    </div>
</template>

<script>
import PremiumLabel from "@/components/PremiumLabel.vue";
export default {
    props: {
        nav: { type: Object, required: true },
        current: { type: String },
        hash: { type: String },
        version: { type: String }
    },
    components: { PremiumLabel }
};
</script>

<style lang="scss">
@use "@/scss/custom";

.menu {
    margin-right: 15px;

    button {
        text-align: left;
        background-color: white;
        padding: 0.6rem 1.5rem;
        padding-right: 0;
        border-radius:10px;

        &.active {
            background-color: custom.$background-light;
            font-weight: bold;
        }

        &:hover {
            background-color: custom.$light;
        }

        &:focus {
            box-shadow: none
        }

        &[disabled] {
            background-color: transparent;
        }

        &.premium {
            position: relative;

            .premium_label {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
